// extracted by mini-css-extract-plugin
module.exports = {"widget":"mtWidget_widget__QEJf7","wrapper":"mtWidget_wrapper__2mR-Q","message":"mtWidget_message__3UVL5"};